import { render, staticRenderFns } from "./delivery-ebe.vue?vue&type=template&id=123504ca"
import script from "./delivery-ebe.vue?vue&type=script&lang=js"
export * from "./delivery-ebe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports